<template>
  <div class="info_content">
    <div class="info_contnet_list">
      <ul>
        <li @click="showCustomPicker('LicenseClass')">
          <span>驾驶证类型</span>
          <span v-if="formInfodata.driverLicenseClass"
            >{{ formInfodata.driverLicenseClass
            }}<img src="@/assets/images/xuanze.png"
          /></span>
          <span v-else>请选择<img src="@/assets/images/xuanze.png"/></span>
        </li>
        <li class="checkformat" v-if="isEmptyDLC">
          <span></span
          ><span style="color: #e30000"
            ><img src="@/assets/images/errorTips.png" />驾驶证类型不能为空</span
          >
        </li>
        <li @click="showDate('firstIssueDate')">
          <span>初次领证日期</span>
          <span v-if="formInfodata.firstIssueDate"
            >{{ formInfodata.firstIssueDate
            }}<img src="@/assets/images/xuanze.png"
          /></span>
          <span v-else>请选择<img src="@/assets/images/xuanze.png"/></span>
        </li>
        <li class="checkformat" v-if="drivingExperienceTips">
          <span></span
          ><span style="color: #e30000"
            ><img src="@/assets/images/errorTips.png" />您的驾龄未达到标准</span
          >
        </li>
        <li class="checkformat" v-if="isEmptyFID">
          <span></span
          ><span style="color: #e30000"
            ><img src="@/assets/images/errorTips.png" />驾驶证初次领证日期不能为空</span
          >
        </li>
        <li @click="showDate('licenseExpiryDate')">
          <span>有效截止日期</span>
          <span v-if="formInfodata.licenseExpiryDate"
            >{{ formInfodata.licenseExpiryDate
            }}<img src="@/assets/images/xuanze.png"
          /></span>
          <span v-else>请选择<img src="@/assets/images/xuanze.png"/></span>
        </li>
        <li class="checkformat" v-if="isEmptyLED">
          <span></span
          ><span style="color: #e30000"
            ><img src="@/assets/images/errorTips.png" />驾驶证有效截止日期不能为空</span
          >
        </li>
        <li class="checkformat" v-if="drivingExpiryDateTips">
          <span></span
          ><span style="color: #e30000"
            ><img src="@/assets/images/errorTips.png" />证件已失效无法注册</span
          >
        </li>
        <li :class="errorTips ? 'errorBorder' : ''">
          <span>驾驶证档案编号</span>
          <span>
            <input
              type="text"
              class="licenseFileNumber"
              placeholder="请输入"
              @blur.capture="handleBug"
              v-model="formInfodata.licenseFileNumber"
              oninput="if(value.length>12)value=value.slice(0,12)"
              @blur="handleBlur"
              @focus="handleFocus"
            />
          </span>
        </li>
        <li class="checkformat" v-if="errorTips">
          <span></span
          ><span style="color: #e30000"
            ><img
              src="@/assets/images/errorTips.png"
            />请输入正确的驾驶证档案编号</span
          >
        </li>
        <li class="checkformat" v-if="isEmptyLFN">
          <span></span
          ><span style="color: #e30000"
            ><img src="@/assets/images/errorTips.png" />驾驶证档案编号不能为空</span
          >
        </li>
      </ul>
    </div>
    <!-- <div :class="!isTrigger?'info_content_dis_btn' : 'info_content_dis_btn info_content_btn'" @click="nextStep">下一步</div> -->
    <van-popup v-model="showPicker" position="bottom">
      <customPicker
        :columns="columns"
        @confirmPicker="confirmPicker"
        @cancelPicker="cancelPicker"
      ></customPicker>
    </van-popup>
    <van-popup v-model="showDatePicker" position="bottom">
      <DateTimePicker
        v-if="showDatePicker"
        :showDatePicker="showDatePicker"
        :minDate="minDate"
        :maxDate="maxDate"
        @confirm="onConfirmDate"
        @cancel="onCancel"
        :currentDate="currentDate"
      ></DateTimePicker>
    </van-popup>
  </div>
</template>

<script>
import DateTimePicker from "@/components/dateTimePicker";
import customPicker from "@/components/customPicker";
import { handleBuryPoint } from "@/utils/tool.js";
export default {
  data() {
    return {
      subSource: "",
      columns: [],
      showPicker: false,
      showDatePicker: false,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      errorTips: false,
      ageTips: false,
      drivingExperienceTips: false,
      formDataInfo: {},
      formContent: false,
      drivingExpiryDateTips: false
    };
  },
  components: {
    DateTimePicker,
    customPicker
  },
  props: {
    formInfodata: {
      type: Object,
      default: () => {}
    },
    showDriverTipsInfo: {
      type: Boolean,
      default: false
    },
    driverAgeRule: {
      type: Number,
      default: 0
    },
    isEmptyDLC: {
      type: Boolean,
      default: false
    },
    isEmptyFID: {
      type:Boolean,
      default: false
    },
    isEmptyLED: {
      type: Boolean,
      default: false
    },
    isEmptyLFN: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showDriverTipsInfo(n, o) {
      //n为新值,o为旧值;
      this.drivingExperienceTips = n;
    }
  },
  mounted() {},
  computed: {
    getCurrentDay() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      month = month > 9 ? month : "0" + month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    },
    // 计算驾龄
    dateDiff() {
      return function(val) {
        let flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
        let start = new Date(val);
        let end = new Date();
        let year = end.getFullYear() - start.getFullYear();
        let month = end.getMonth() - start.getMonth();
        let day = end.getDate() - start.getDate();
        if (month < 0) {
          year--;
          month = end.getMonth() + (12 - start.getMonth());
        }
        if (day < 0) {
          month--;
          let index = flag.findIndex(temp => {
            return temp === start.getMonth() + 1;
          });
          let monthLength;
          if (index <= 6) {
            monthLength = 31;
          } else if (index > 6 && index <= 10) {
            monthLength = 30;
          } else {
            monthLength = 28;
          }
          day = end.getDate() + (monthLength - start.getDate());
        }
        return year;
      };
    }
  },
  methods: {
    // 点击对应的picker项
    showCustomPicker(val) {
      this.pickerCode = val;
      if (this.pickerCode == "LicenseClass") {
        this.columns = ["A1", "A2", "A3", "B1", "B2", "C1"];
      }
      this.showPicker = true;
    },
    // 确认选择的picker值
    confirmPicker({ data, value, showPicker }) {
      if (this.pickerCode == "LicenseClass") {
        handleBuryPoint(
          "recruiting-Information",
          "driverLicenseType_Click",
          {}
        );
        this.formInfodata.driverLicenseClass = value;
        this.$emit("handleHideDriverTips", false)
      }
      this.showPicker = showPicker;
    },
    cancelPicker({ showPicker }) {
      this.showPicker = showPicker;
    },
    showCard() {
      this.showCardPicker = true;
    },
    showDate(val) {
      if (val == "firstIssueDate") {
        this.minDate = new Date(1960, 0, 1);
        this.maxDate = new Date(2050, 11, 1);
        this.currentDate = new Date();
      } else {
        this.minDate = new Date(2000, 0, 1);
        this.maxDate = new Date(2100, 11, 1);
        this.currentDate = new Date();
      }
      this.code = val;
      this.showDatePicker = true;
    },
    onConfirm(value) {
      this.formInfodata.sex = value;
      this.showPicker = false;
    },
    onConfirmDate({ data, value, showDatePicker }) {
      if (this.code == "firstIssueDate") {
        handleBuryPoint(
          "recruiting-Information",
          "dateOfFirstApplication_Click",
          {}
        );
        this.formInfodata.firstIssueDate = value;
        if (this.entryRuleState == 1) {
          this.drivingExperienceTips =
            this.dateDiff(value) < this.driverAgeRule ? true : false;
        }
        this.$emit("handleHideDriverTips", false)
      } else {
        handleBuryPoint("recruiting-Information", "expiryDate_Click", {});
        this.formInfodata.licenseExpiryDate = value;
        this.drivingExpiryDateTips = value < this.getCurrentDay ? true : false;
        this.$emit("handleHidelicenseExpiryDateTips", false)
      }
      this.showDatePicker = showDatePicker;
    },
    onCancel({ showDatePicker }) {
      this.$forceUpdate();
      this.showDatePicker = showDatePicker;
    },
    // 兼容ios键盘弹起界面不恢复原状态
    handleBug() {
      let scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    },
    // 驾驶证档案号失焦的时候进行正则验证
    handleBlur() {
      const idNumberReg = /^\d{12}$/;
      if (!idNumberReg.test(this.formInfodata.licenseFileNumber)) {
        this.errorTips = true;
        this.isEmptyLFN = false
      } else {
        this.errorTips = false;
      }
      this.$emit("receveErrorStatus", {
        errorTips: this.errorTips,
        isEmptyLFN: false
      });

      const ua = window.navigator.userAgent.toLocaleLowerCase();
      const isAndroid = /android/.test(ua);
      if (isAndroid) {
        const container = document.getElementsByClassName("home")[0];
        const height = container.clientHeight;
        container.setAttribute("style", `height: ${height - 288}px`);
        window.scrollTo(0, container.clientHeight);
      }
    },
    handleFocus() {
      const ua = window.navigator.userAgent.toLocaleLowerCase();
      const isAndroid = /android/.test(ua);
      if (isAndroid) {
        const container = document.getElementsByClassName("home")[0];
        const height = container.clientHeight;
        container.setAttribute("style", `height: ${height + 288}px`);
        console.log("height", height);
        console.log("container", container.clientHeight);
        window.scrollTo(0, height);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-picker__toolbar {
  height: 80px;
}
/deep/ .van-picker-column {
  font-size: 30px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  font-size: 30px;
}
/deep/ .van-picker__title {
  font-size: 25px;
  line-height: 35px;
}
.info_content {
  // height: 100vh;
  background: #f5f5f5;
  .info_contnet_list {
    background: #ffffff;
    // margin-bottom: 61px;
    ul {
      li:first-child {
        p:nth-of-type(2) {
          span:first-child {
            color: #176af0;
          }
        }
      }
      li {
        display: flex;
        justify-content: space-between;
        padding: 0px 24px;
        font-size: 32px;
        color: #333333;
        height: 112px;
        line-height: 112px;
        border-bottom: 1px solid #e0e0e0;
        input {
          background: none;
          outline: none;
          display: flex;
          flex: 1;
          width: 370px;
          // height: 70px;
          border: none;
          text-align: right;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #176af0;
        }
        span {
          img {
            width: 20px;
            height: 40px;
            margin-left: 20px;
            vertical-align: middle;
          }
        }
        span:nth-of-type(2) {
          color: #176af0;
        }
      }
    }
    .errorBorder {
      border-bottom: 1px solid #e30000;
    }
    .checkformat {
      font-size: 24px;
      color: #e30000;
      line-height: 50px;
      height: 50px;
      border-bottom: none;
      img {
        position: relative;
        bottom: 2px;
        margin-right: 10px;
        width: 28px;
        height: 28px;
      }
    }
  }
}
</style>
